module.exports = __webpack_public_path__ + "img/logo-no-text.491b86a1.svg";